export default {"src":"/_next/static/media/iuva.57c24ca0.svg","height":47,"width":83};